import { useQuery } from "@tanstack/react-query";
import { spySerpService } from "@/services/SpySerpService";

export interface SpyserpDomainKeywordsQueryParams {
  isOpen: boolean;
  domain: string | null;
  startDate?: string;
  endDate?: string;
  rankLimit?: number;
}

export const getSpyserpDomainKeywordsQueryKey = ({
  domain,
  startDate,
  endDate,
  rankLimit,
}: Omit<SpyserpDomainKeywordsQueryParams, "isOpen">) =>
  [
    "spyserp",
    "domainKeywords",
    domain,
    startDate ?? null,
    endDate ?? null,
    rankLimit ?? null,
  ] as const;

export const useSpyserpDomainKeywords = ({
  isOpen,
  domain,
  startDate,
  endDate,
  rankLimit,
}: SpyserpDomainKeywordsQueryParams) =>
  useQuery({
    queryKey: getSpyserpDomainKeywordsQueryKey({
      domain,
      startDate,
      endDate,
      rankLimit,
    }),
    queryFn: () =>
      spySerpService.getDomainKeywords({
        domain: domain!,
        startDate: startDate!,
        endDate: endDate!,
        rankLimit,
      }),
    enabled: isOpen && !!domain && !!startDate && !!endDate,
    staleTime: 1000 * 60 * 5,
  });
